"use client";

import { useRouter, usePathname } from "next/navigation";
import { Icon } from "@iconify/react";
import { FileUploader } from "@/components/ui/FileUploader";
import { usePdfFile } from "@/lib/pdf-editor/FileContext";
import { getLocaleFromPathname, withLocale } from "@/lib/i18n";
import { tools } from "@/config/tools";
import { getLocalizedTool } from "@/lib/tool-localization";

export function AddWatermark() {
  const router = useRouter();
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const { setPdfFile } = usePdfFile();
  const localizedTool = getLocalizedTool(
    tools.find((item) => item.id === "add-watermark") ?? tools[0],
    locale
  );

  const handleFilesSelected = (files: File[]) => {
    if (files.length > 0) {
      const pdfFile = files[0];
      // Store PDF File object in context (it will create URL internally)
      setPdfFile(pdfFile);
      
      // Redirect to document editor with watermark feature
      router.push(withLocale(locale, '/document/create?feature=watermark'));
    }
  };

  return (
    <div className="space-y-8">
      <div className="rounded-[20px] border border-positivus-dark/10 bg-positivus-green/10 p-6">
        <div className="flex items-start gap-4">
          <div className="hidden md:block rounded-full bg-positivus-green/20 p-2">
            <Icon icon="mdi:watermark" className="h-6 w-6 text-positivus-dark" />
          </div>
          <div className="text-sm text-positivus-dark w-full">
            <p className="font-medium text-lg mb-2">{localizedTool.name}</p>
            <p className="leading-relaxed">{localizedTool.description}</p>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <FileUploader 
          accept=".pdf" 
          onFilesSelected={handleFilesSelected}
        />
      </div>
    </div>
  );
}
